import React, {ReactElement} from 'react';
import {EventKind} from 'services/analytics';
import {compose} from 'shared/utils/compose';
import {lazy} from 'shared/utils/lazy';
import {useHistoryStore} from 'store/History';

import {DeleteRecord, DeleteRecordProps} from 'ui/adapters/Core';
import {useAnalytics, DetailedRegistrator} from 'ui/adapters/Analytics';

import {Deletable} from 'components/Deletable';
import {Center} from 'components/Center';
import {Record} from 'components/Record';
import {Wrapper} from './style';

export const History = (): ReactElement => {
  const history = useHistoryStore();
  const sorted = history.slice().sort((a, b) => b.dateTime - a.dateTime);
  const registerEventWith = useAnalytics<DetailedRegistrator>(EventKind.DeleteSpend);

  return (
    <Wrapper>
      <Center className='center'>
        <DeleteRecord>
          {({deleteRecord}: DeleteRecordProps) => (
            <>
              {sorted.map((record: RecordEntry, index: number) => (
                <div data-test='record' key={record.dateTime}>
                  <Deletable
                    onDelete={compose(lazy(deleteRecord, record), lazy(registerEventWith, index))}
                  >
                    <Record record={record} />
                  </Deletable>
                </div>
              ))}
            </>
          )}
        </DeleteRecord>
      </Center>
    </Wrapper>
  );
};
